interface OfficePreviewUnavailableProps {
  onDownload?: () => void;
}

export function OfficePreviewUnavailable({ onDownload }: OfficePreviewUnavailableProps) {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="max-w-md text-center">
        <p className="text-sm text-slate-700">This presentation could not be previewed.</p>
        {onDownload ? (
          <button
            type="button"
            onClick={onDownload}
            className="mt-3 text-sm font-medium text-crimson hover:underline"
          >
            Download original file
          </button>
        ) : null}
      </div>
    </div>
  );
}
